import { ajax } from "rxjs/ajax";
import axios from "axios";
const _ = require("lodash");

export default {
  login: user => {
    return ajax.post("/api/web/login", user, {
      "Content-Type": "application/json"
    });
  },
  forgotPassword: user => {
    let apiOptions = {
      headers: {
        Accept: "application/vnd.api+json",
        "Content-Type": "application/vnd.api+json"
      }
    };

    return axios.post("/api/auth/password", user, apiOptions);
  },
  resetPassword: user => {
    var item = _.cloneDeep(user);
    delete item.user["confirmPassword"];

    let apiOptions = {
      headers: {
        Accept: "application/vnd.api+json",
        "Content-Type": "application/vnd.api+json",
        uid: item.user.email
      }
    };

    return axios.put("/api/auth/password", item, apiOptions);
  }
};



// WEBPACK FOOTER //
// ./src/services/loginService/index.js